import GraceListRowButton from './ListRowButton';

const GraceTrackingLinks = ({ trackingLinks }) => {
  return trackingLinks.map((trackingLink, index) => {
    const linkText = trackingLinks.length > 1 ? ` (${index + 1} of ${trackingLinks.length})` : '';
    const openLinkOption = { name: 'View tracking information' + linkText };

    return (
      <section className="mx-4" key={index}>
        <GraceListRowButton option={openLinkOption} onClick={() => window.open(trackingLink)} />
      </section>
    );
  });
};

GraceTrackingLinks.propTypes = {
  trackingLinks: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default GraceTrackingLinks;
